import { arrayRemove, doc, updateDoc } from "firebase/firestore";

import { db } from "../firebase";

const removeFCMToken = async (uid: string, fcmToken: string) => {
  const userRef = doc(db, `users/${uid}`);
  await updateDoc(userRef, {
    fcmToken: arrayRemove(fcmToken),
  });
};
export default removeFCMToken;
